module.exports = __webpack_public_path__ + "static/20-7-be4477f04a7cf964de805729dafbc896.jpg";